module.exports = __webpack_public_path__ + "e060dc243dde6b3247dc5e28d414ddf0.jpg";